export const PREVIEW_ACCOUNT_MENU_DOTS_ICON = 'icon-menu-dots';
